<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
>
  <path
    fill="#ffffff"
    d="M106.68 277.328h216.973l-70.25 70.25 30.167 30.167 121.75-121.75-121.75-121.74-30.167 30.167 70.247 70.24H106.68z"
  />
</svg>
